import gql from "graphql-tag";

export const UPDATE_PERSONAL_INFO = gql`
    mutation UpdatePersonalInfo(
        $displayName: String, $username: String, $birthday: String, $sex: String, $location: String,
        $workplace: String, $websiteUrl: String, $phoneNumber: String, $profession: String, $biography: String,
        $twitterLink: String, $facebookLink: String
    ) {
        updatedUser: updatePersonalInfo(input: {
            displayName: $displayName, username: $username, birthday: $birthday, sex: $sex, location: $location,
            workplace: $workplace, websiteUrl: $websiteUrl, phoneNumber: $phoneNumber, profession: $profession,
            biography: $biography, twitterLink: $twitterLink, facebookLink: $facebookLink
        }) {
            user {
                username
                email
                dateJoined
                profile {
                    displayName
                    sex
                    location
                    profession
                    workplace
                    biography
                    websiteUrl
                    twitterLink
                    facebookLink
                    birthday
                    phoneNumber
                }
                tagFavoriteSet {
                    edges {
                        node {
                            name
                        }
                    }
                }
            }
        }
    }
`;